import * as React from 'react';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'moduleBase/types/State';
import { InitResponse } from 'moduleBase/actions/types/InitResponseType';
import { REDUCER_GLOBAL_NAME } from 'moduleBase/constants';
import { LangsMenuItem } from 'moduleBase/components/header/components/LangsMenu/LangsMenuItem';

const LangsMenuList: FC = () => {
  const languageSettings = useSelector<State, InitResponse['languageSettings']>(
    (state) => state[REDUCER_GLOBAL_NAME].languageSettings,
  );

  return (
    <>
      {languageSettings.list.map((language) => (
        <li key={language.name}>
          <LangsMenuItem
            currentPageUrl={language.currentPageUrl}
            isActive={language.isActive}
            name={language.name}
          />
        </li>
      ))}
    </>
  );
};

export { LangsMenuList };
